import React, { Component } from "react";
import { Link } from "gatsby";
import Layout from "./layout";
import "../css/style.css"

class CoursedetailPG extends Component {
  
render(){
  return(

    <div class="online-journey-inner">
    <div class="row"> 
        <div class="col-md-6">
            <div class="text-box wow fadeInLeft pl-0 mt-2 mt-md-0" data-wow-duration="1s" data-wow-delay=".2s">
                <h3>Admissions information</h3> 
                <ul>
                    <li id="crcs">
                        <h4>Route 1: Degree only</h4>
                        
                            <span className="" >Academics: {this.props.DirectAcadenic}</span>
                            <span className="">English: {this.props.DirectEnglish}</span>
                            {this.props.DirectOther? (<span className="">Other: {this.props.DirectOther}</span>):("")}
                    
                    </li>
                    <li id="crc">
                        <h4>Route 2: Pre-Masters Program + Degree </h4>
                        <span className="">Academics: {this.props.QualificationInfo}</span>
                            <span className="">English: {this.props.EnglishRequirments}</span>
{this.props.OtherRequirments ? (<span className="">Other: {this.props.OtherRequirments}</span>):("")}
                    </li>
                    <li id="crc1">
                        <h4>fees and scholarships</h4>
                        <span>
                        Pre-Masters Program:  {this.props.OnlineFees}          
                        </span>
                        <span>
                        Masters Program:{this.props.CampusFees}  
                        
                        </span>
                    </li>
                </ul> 
            </div>
        </div>
        <div class="col-md-6">
            <div class="image-holder wow fadeInRight" data-wow-duration="1s" data-wow-delay=".1s">
                <img src="https://media.publit.io/file/TheWorldgrad/2Programdetailedpage/pexels-kelly-lacy-2928232-min_znehfb.jpg" alt="" class="img-fluid" />
            </div>
        </div>
    </div> 
</div>
  )
}

}

export default CoursedetailPG;